import { API_ROOT, sendRequest } from '../../../supplementary_components/requests';

export function formatFuelCardStatusLabel(status) {
    if (status !== 'ACTIVE' && status !== 'INACTIVE' && status !== 'HOLD') {
        return 'BLOCKED (FRAUD)';
    }
    return status;
}

export function isFuelCardStatusToggleable(status) {
    return status === 'ACTIVE' || status === 'INACTIVE';
}

export function requestFuelCardStatusChange({ fuelCardId, desiredStatus, truckId, onSuccess, onError }) {
    sendRequest(
        'POST',
        API_ROOT + 'fuelcards/change-status',
        null,
        onSuccess,
        onError,
        { id: fuelCardId, desiredStatus, truckId: truckId ?? null },
    );
}
